import { DIR } from '@/services/localhost';


    // ROOT
        export function rootAuth(token=``)
        {
            if(token){
                localStorage.setItem(`rootAth_${DIR()}`, token);
                return token;

            } else {
                return localStorage.getItem(`rootAth_${DIR()}`);
            }
        }

        export function rootAuth_remove()
        {
            localStorage.removeItem(`rootAth_${DIR()}`);
        }
    // ROOT


    // ADMIN
        export function adminAuth(){
            if(localStorage.getItem(`adminAth_${DIR()}`)){
                return localStorage.getItem(`adminAth_${DIR()}`);
            }
            if(localStorage.getItem(`adminAth_${DIR()}/admin`)){
                return localStorage.getItem(`adminAth_${DIR()}/admin`);
            }
        }
    // ADMIN

    // LOGOUT
        export function logout()
        {
            window.location = `${DIR()}/login/logout/`;
        }
    // LOGOUT
